/**
 * Redakční systém JSR
 * e_filtry.js
 * Funkce pro odeslání formuláře s filtry eshopu
 *
 * @package eshop
 *
 * @author Jiří Chalupný <jchalupny@skit.cz>
 * @copyright (c) 2007-2025 Josef Šmíd
 * @version 2.5.9
 */

$(document).ready(function ()
{
  $("#form_filtry").submit(function () {
    OdesliForm();
    return false;
  });

  $(".filtr_polozka").change(function () {        
    if ( $('body').width() <= 992 && $(this).attr("data-typ") !== '-1' && $(this).attr("data-typ") !== '0' ) return false
                                                    
    OdesliForm();
  });

  function OdesliForm()
  {
    var url = "";
    var filtr = "";
    var vse = 0;
    $('.filtr_polozka').each(function ()
    {
      if ( $(this).attr("data-typ") === '-1' && $(this).is(':checked') )
        vse = 1;
      if ( $(this).attr("data-typ") === '0' && $(this).is(':checked') )
        url += (url !== "" ? "&" : "") + $(this).attr("name") + "=" + $(this).val();
      else
      {
        if ( (($(this).attr("data-typ") === '1' || $(this).attr("data-typ") === '2') && $(this).is(':checked') ) ||
                ($(this).attr("data-typ") === '5' && $(this).val() !== ""))
        {
          filtr += (filtr !== "" ? ";;" : "") + $(this).attr("name") + ";" + $(this).val();
        } 
        else if ( $(this).attr("data-typ") === '3' && $(this).find('option:selected').val() !== "" )
        {
          filtr += (filtr !== "" ? ";;" : "") + $(this).attr("name") + ";" + $(this).find('option:selected').attr("data-val");
        } 
        else if ( $(this).attr("data-typ") === '4' && $(this).val() !== $(this).attr("data-def") )
        {
          filtr += (filtr !== "" ? ";;" : "") + $(this).attr("name") + ";" + $(this).val();
        }
      }
    });
    if (vse === 1) 
    {
      url = filtr = "";
    }
    window.location.href = ($("#url_filtr").val() + "?" + url + (url !== "" && filtr !== "" ? "&" : "") + (filtr !== "" ? "filtr=" + filtr : ""));
  }

  $(".slider-range").each(function (index, element) {
    var min = parseInt($(element).parent('.range_filter').children('.filtr_min').attr('data-def'));
    var max = parseInt($(element).parent('.range_filter').children('.filtr_max').attr('data-def'));
    var val_min = parseInt($(element).parent('.range_filter').children('.filtr_min').val());
    var val_max = parseInt($(element).parent('.range_filter').children('.filtr_max').val());
    $(element).empty().slider({
      range: true,
      min: min,
      max: max,
      values: [val_min, val_max],
      slide: function (event, ui) {
        $(this).parent('.range_filter').children('.filtr_min').val(ui.values[0]);
        $(this).parent('.range_filter').children('.filtr_max').val(ui.values[1]);

      },
      stop: function (event, ui) {
        if ( $('body').width() > 992 )
          OdesliForm();
      }
    });

    $(element).parent('.range_filter').children('.filtr_min').on('keyup', function () {
      if ($(this).val() < max && $(this).val() < $(element).slider('values', 1)) {
        $(element).slider('values', 0, $(this).val());
      }
    });
    $(element).parent('.range_filter').children('.filtr_max').on('keyup', function () {
      if ($(this).val() > min && $(this).val() > $(element).slider('values', 0)) {
        $(element).slider('values', 1, $(this).val());
      }
    });
  });
  $('img[title]').tooltip(
          {
            tooltipClass: "tooltip",
            content: function () {
              return $(this).prop('title');
            }
          });
  $('.subhead_eshop_new_dalsi').click(function () {
    $(this).hide();
    $('.subhead_eshop_new_hide').removeClass('subhead_eshop_new_hide');
  });

  $('.razeni_zobr_filtr, .razeni_zobr_filtr_seda , .filter_zavrit, .close_tablet').click(function () {
    if ($('#produkty_filtry').is(":hidden"))
    {
      $('.razeni_zobr_filtr_seda').show();
      $( '#eshop_produkty' ).addClass( "zobrazen_filter" );
      $( '#dalsi_produkty_div' ).addClass( "zobrazen_filter_str" );
      if ($('body').width() <= 600)
      {
        $('#produkty_filtry').show();
        $("#produkty_filtry").animate({left: '0px'}, 100, function () {

        });
        $('.close_tablet').hide();
      } else
      {
        $('#produkty_filtry').show();
        $("#produkty_filtry").animate({left: '0px'}, 100, function () {

        });
        if( window.matchMedia('(max-width: 992px)').matches )
        {
          $('.close_tablet').show();
        }
        $(".close_tablet").animate({left: '50%'}, 100, function () {

        });
      }
    } 
    else
    {
      $('.razeni_zobr_filtr_seda').hide();
      $( '#eshop_produkty' ).removeClass( "zobrazen_filter" );
      $( '#dalsi_produkty_div' ).removeClass( "zobrazen_filter_str" );
      if ($('body').width() <= 600)
      {
        $("#produkty_filtry").animate({left: '-100%'}, 100, function () {
          $('#produkty_filtry').hide();
          $('.close_tablet').hide(); 
        });
      } else
      {
        $("#produkty_filtry").animate({left: '-50%'}, 100, function () {
          $('#produkty_filtry').hide();
        });

        $(".close_tablet").animate({left: '0px'}, 100, function () {
          $('.close_tablet').hide(); 
        });
      }
    }
  });
  /*$(".razeni_select").each(function (index, element) {
    $(element).find('.filter_vybrano').each(function (index, element_sec) {
      $(element_sec).closest('.razeni_select').children('.razeni_select_btn').children('span').text($(element_sec).prop("innerText"));
      return false;
    });
  });*/
  $('.razeni_button').click(function () {

    if ( window.matchMedia('(max-width: 992px)').matches)
    {
      $(this).closest('.razeni_select').children('.razeni_select_btn').children('span').text($(this).prop("innerText"));
      $(this).closest('.razeni_select').removeClass("active");
      $(this).closest('.razeni_select').children('.razeni_buttons_select').slideUp();
    }

  });
  $('.razeni_select_btn').click(function () {

    if ($(this).parent('.razeni_select').children('.razeni_buttons_select').is(":hidden"))
    {
      $(".razeni_buttons_select").slideUp();
      $('.active').removeClass("active");
      $(this).parent('.razeni_select').addClass("active");
      $(this).parent('.razeni_select').children('.razeni_buttons_select').slideDown();
    } else
    {
      $(this).parent('.razeni_select').removeClass("active");
      $(this).parent('.razeni_select').children('.razeni_buttons_select').slideUp();
    }
  });

  /*$(window).bind("resize", function (e) { 
    if (window.matchMedia('(max-width: 992px)').matches )
    {
      if ($('#produkty_filtry').is(":visible") && $('.razeni_zobr_filtr').is(":visible"))
      {
        $('.razeni_zobr_filtr_seda').show();
        if ($('body').width() <= 600)
        {
          $('#produkty_filtry').show();
          $("#produkty_filtry").css('left', '0px');
          $('.close_tablet').hide();
        } else
        {
          $('#produkty_filtry').show();
          $("#produkty_filtry").css('left', '0px');
          $('.close_tablet').show();
          $(".close_tablet").css('left', '50%');
        }
      }
    }
    else
    {
      $('.razeni_buttons_select').show();
      $("#produkty_filtry").removeAttr('style');
      $(".close_tablet").hide();
      $(".razeni_zobr_filtr_seda").hide();
    }
  });
  $(window).bind("resize scroll", function (e) {
    if ( window.matchMedia('(max-width: 992px)').matches && $('.razeni_buttons_select').is(":visible"))
    {
      $('.razeni_buttons_select').slideUp();
      $('.active').removeClass("active");
    }
  });
  $(window).click(function (e) {
    if ( window.matchMedia('(max-width: 992px)').matches && $('.razeni_buttons_select').is(":visible"))
    {
      var container = $(".razeni_select_btn");
      if (!container.is(e.target) && container.has(e.target).length === 0)
      {
        $('.razeni_buttons_select').slideUp();
        $('.active').removeClass("active");
      }
    }
  });*/
});









